import React from 'react';
import { BiChevronRight } from 'react-icons/bi';
import { useMutation } from 'react-query';
import { signout } from 'src/apis/auth';
import { WEBSITE_URL, RECRUITER_APP_ENDPOINT } from 'src/config/env.config';
const MoreOptions = () => {
	const signoutFn = useMutation(['signout'], signout, {
		onSuccess() {
			window.open(`${RECRUITER_APP_ENDPOINT}/auth/signin`, '_self');
		},
	});
	const navbarOptions = [
		// {
		// 	optionText: 'My Team',
		// 	isExternal: false,
		// 	pathOrUrl: '',
		// },
		// {
		// 	optionText: 'Company Page',
		// 	isExternal: false,
		// 	pathOrUrl: '',
		// },
		// {
		// 	optionText: 'How LevelUp Works?',
		// 	isExternal: false,
		// 	pathOrUrl: '',
		// 	onClick: () => {
		// 		window.open(`${WEBSITE_URL}/how-levelup-works`, '_blank');
		// 	},
		// },
		{
			optionText: 'Support',
			isExternal: false,
			pathOrUrl: '',
			onClick: () => {
				window.open(`${WEBSITE_URL}/support`, '_blank');
			},
		},
		{
			optionText: 'Logout',
			isExternal: false,
			pathOrUrl: '',
			onClick: () => {
				signoutFn.mutate();
			},
		},
	];
	return (
		<div className="p-[16px] grid gap-[16px]">
			{navbarOptions.map(item => {
				return (
					<div onClick={item.onClick} className="flex gap-[12px] items-center justify-between cursor-pointer">
						<p className="font-inter text-[14px] font-[500] leading-[20px] text-[#28293D]">{item.optionText}</p>
						<BiChevronRight color="#7777E7" className="w-[24px] h-[24px]" />
					</div>
				);
			})}
		</div>
	);
};

export default MoreOptions;
